// extracted by mini-css-extract-plugin
export default {"buttons":"LinksCenter_buttons__Rp2Sr"};